/** Naval composition stays separate from the surface city's camera and water treatment. */
import type { WaterParams } from './waterQuality.ts';

/** Retain the surface in memory without rendering unrelated streets during combat. */
export function createSeaBackdropFocus(): {
  enter(roots: readonly { visible: boolean }[]): void;
  leave(): void;
} {
  const visibility = new Map<{ visible: boolean }, boolean>();
  return {
    enter(roots) {
      for (const root of roots) {
        if (!visibility.has(root)) visibility.set(root, root.visible);
        root.visible = false;
      }
    },
    leave() {
      for (const [root, visible] of visibility) root.visible = visible;
      visibility.clear();
    },
  };
}

/** Keep water motion and collision mirrors intact; reserve bright, sharp marks for attacks. */
export function seaCombatWater(base: WaterParams): WaterParams {
  return {
    ...base,
    bandGain: Math.min(base.bandGain, 0.015),
    waveLineStrength: Math.min(base.waveLineStrength, 0.012),
    causticStrength: Math.min(base.causticStrength, 0.02),
    glintStrength: Math.min(base.glintStrength, 0.035),
    fresnelStrength: Math.min(base.fresnelStrength, 0.055),
    underseaStrength: Math.min(base.underseaStrength, 0.015),
  };
}

export { seaCombatCamera } from './interiorSeaCamera.ts';
